import React from "react";
import RecipeForm from "../RecipeForm/RecipeForm";
import Layout from "../../Layout/Layout";

const AddRecipe = () => {
  return (
    <Layout>
      <RecipeForm />
    </Layout>
  );
};

export default AddRecipe;
